/**
 * UAT 唯讀模式（分支 feat/uat-readonly）。
 *
 * 客戶驗收期間要降低驗收狀況:全站只留「預覽」,把新增／編輯／刪除
 * （含送審、結案、撤回、轉派、暫停等一切會寫入的動作）整批藏起來。
 * 唯一例外是**軟體／硬體的批次匯入** —— 客戶要自己匯資料,所以保留,
 * 而且不走審核。
 *
 * 做法不是逐頁改按鈕,而是在四個共用關卡集中判斷(改一處、全站生效):
 *   1. RBAC `can()`:`*.create / *.update / *.delete` 一律回 false
 *      → 所有 `<RbacGuard perm="room.create">`、`can("room.update")` 這類入口自動消失。
 *   2. `<RowIconActions>`:列尾只留「檢視」。
 *   3. `<DetailView actions>`:詳情頁右上的動作列不渲染。
 *   4. `<WriteAction>`:包住那些「不依角色藏」的裸按鈕(新增／批次匯入)。
 *   另外 `<BatchImportModal>` 在此模式下不再出現「送出審核」字樣。
 *
 * **預設開啟**:這條分支的用途就是唯讀驗收站,build 出來就是唯讀。
 * 要關掉(回到正常可寫的產品)設 `REACT_APP_READ_ONLY=off`;
 * `.env.test` 已設 off,既有測試套件跑的是完整產品,唯讀行為另有專測。
 *
 * 讀成函式而不是模組常數(與 approvalStepEnabled 同一個理由):模組常數在
 * import 當下就定死,測試沒辦法在同一個檔案裡同時涵蓋開／關兩條路。
 */
const warnedValues = new Set();
export const isReadOnlyMode = () => {
  const v = process.env.REACT_APP_READ_ONLY;
  // 認不得的值(例:2026-10-21 本機 .env 打成 falase)照舊當唯讀,但要講出來 ——
  // 否則症狀只是「新增／編輯按鈕全不見」,看不出是設定打錯
  if (v !== undefined && v !== "on" && v !== "off" && !warnedValues.has(v)) {
    warnedValues.add(v);
    console.warn(`[readOnlyMode] REACT_APP_READ_ONLY=${v} 認不得,只認 off／on;目前當成唯讀(新增／編輯／刪除全藏)`);
  }
  return v !== "off";
};

/** `資源.動作` 裡屬於寫入的動作;唯讀模式下這些一律不給。 */
export const isWriteAction = (perm) => /\.(create|update|delete)$/.test(String(perm));
